import { PropsWithChildren } from 'react';

const MainContent: React.FC<PropsWithChildren> = ({ children }) => (
  <main className='mx-8 my-8 sm:mx-12 lg:mx-16 lg:my-12 flex-grow' id='maincontent'>
    {children}
  </main>
);

export default MainContent;
